module.exports = require("/var/www/alfredmountfield.com/.gatsby/gatsby-browser.ts");